export type Roles = 0 | 1 | 2;

export const Roles = {
  SuperAdmin: "SuperAdmin" as const,
  Admin: "Admin" as const,
  Cuenta: "Cuenta" as const,
  isSuperAdmin: (role: any) => role === 0 || role === "SuperAdmin",
  isAdmin: (role: any) => role === 1 || role === "Admin",
  isCuenta: (role: any) => role === 2 || role === "Cuenta",
};

export default Roles;
